export const
    TURN_ON_SIDEBAR_FLOAT_BOAT = 'TURN_ON_SIDEBAR_FLOAT_BOAT',
    TURN_OFF_SIDEBAR_FLOAT_BOAT = 'TURN_OFF_SIDEBAR_FLOAT_BOAT',
    SHOW_SIDEBAR = 'SHOW_SIDEBAR',
    HIDE_SIDEBAR = 'HIDE_SIDEBAR',
    TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
    HIDE_SIDEBAR_IF_FLOATING = 'HIDE_SIDEBAR_IF_FLOATING';

export const turnOnSidebarFloatBoat = _ => {
    return {type: TURN_ON_SIDEBAR_FLOAT_BOAT};
};

export const turnOffSidebarFloatBoat = _ => {
    return {type: TURN_OFF_SIDEBAR_FLOAT_BOAT};
};

export const showSidebar = _ => {
    return {type: SHOW_SIDEBAR};
};

export const hideSidebar = _ => {
    return {type: HIDE_SIDEBAR};
};

export const toggleSidebar = _ => {
    return {type: TOGGLE_SIDEBAR};
};

export const hideSidebarIfFloating = _ => {
    return {type: HIDE_SIDEBAR_IF_FLOATING};
};
